
import { useSitePages } from '@/hooks/useCMS'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Layout, Plus, Edit, Eye } from 'lucide-react'

export const CMSPageEditor = () => {
  const { data: pages, isLoading } = useSitePages()

  if (isLoading) {
    return <div>Chargement des pages...</div>
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Layout className="w-5 h-5" />
          <p className="text-gray-600">Gérez les pages de votre site</p>
        </div>
        <Button className="bg-gradient-to-r from-pink-500 to-blue-500">
          <Plus className="w-4 h-4 mr-2" />
          Nouvelle Page
        </Button>
      </div>

      <div className="grid gap-4">
        {pages?.map((page) => (
          <Card key={page.id}>
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle className="flex items-center gap-2">
                  {page.title}
                  <Badge variant={page.is_active ? 'default' : 'secondary'}>
                    {page.is_active ? 'Actif' : 'Inactif'}
                  </Badge>
                </CardTitle>
                <div className="flex items-center gap-2">
                  <Button variant="outline" size="sm">
                    <Edit className="w-4 h-4 mr-1" />
                    Éditer
                  </Button>
                  <Button variant="outline" size="sm">
                    <Eye className="w-4 h-4 mr-1" />
                    Voir
                  </Button>
                </div>
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <p><strong>Slug:</strong> /{page.slug}</p>
                <p><strong>Description:</strong> {page.meta_description || 'Aucune description'}</p>
                <p className="text-sm text-gray-500">
                  Dernière modification: {new Date(page.updated_at).toLocaleDateString('fr-FR')}
                </p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
